export default __webpack_public_path__ + "static/media/avatar-s-5.93e63d8c.jpg";